export default __webpack_public_path__ + "static/media/card6.7a4e6369.jpg";